import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";

//internal import
import QuotationServices from "../services/QuotationServices";
import { notifyError, notifySuccess } from "../utils/toast"; 
import dayjs from "dayjs";
import { allContext } from "../context/AllContext";

const useQuotationSubmit = (id) => { 
  const [viewData, setviewData] = useState([]);  
  const [isModal, setIsModal] = useState(false);   
  const [isViewModal, setIsViewModal] = useState(false); 
  const [isConfirmModal, setIsConfirmModal] = useState(false); 
  const [status, setStatus] = useState("Active");
  const { dataUpdate, setDataUpdate } = useContext(allContext);
  const [imageUrl, setImageUrl] = useState("");

  const { 
    register,
    handleSubmit,
    setValue,
    // clearErrors,
    // reset,
    formState: { errors },
  } = useForm();
 

  const onSubmit = async (scheduleData) => {
    try {     
        
      if (id) {  
        scheduleData.status = status;
        const res = await QuotationServices.updateSchedule(id, scheduleData);
        notifySuccess(res.message);
        setDataUpdate(!dataUpdate);
        setIsModal(false);
      } else {
        scheduleData.status = "Need to Approach";
        const res = await QuotationServices.addSchedule(scheduleData);
        notifySuccess(res.message);
        setIsModal(false);  
        setDataUpdate(!dataUpdate);  
        // window.location.reload();
      }  
      return;
    } catch (err) { 
      notifyError(err ? err?.response?.data?.message : err?.message);
    }
  };   

  const ShowEditValues = async (row, type) => {   
    const result = await QuotationServices.getScheduleById(row._id);
    var resdata = result?.data;
    // console.log(" edit ", result);
    if(result?.success === true) {
      if(type === "Edit") {   
        setValue("employeeId", resdata?.employeeId?._id);
        setValue("clientId", resdata?.clientId?._id);
        setValue("projectType", resdata?.projectType);
        setValue("scheduleDate", dayjs(resdata?.scheduleDate).format("YYYY-MM-DD"));   
        setValue("fromTime", resdata?.fromTime);
        setValue("toTime", resdata?.toTime);
        setValue("status", resdata?.status); 
        setStatus(resdata?.status);
      }else {
        setviewData(resdata);
      }
    }    
  } 
  
  const changeStatusRequest = async (scheduleId) => {  
    // const result = await QuotationServices.updateScheduleStatus(scheduleId, {"status":"request"});
    //var resdata = result?.data;
    // console.log(" result === ", result); 
  } 
  
  const handleConfirmQuotation = async (QuotationId, Stateval) => {
    var result ;
    if(Stateval === "Accept") {
      result = await QuotationServices.updateQuotationStatus(QuotationId, {"status":"Request Accepted", "quotationFile": imageUrl});
    }else { 
      result = await QuotationServices.updateQuotationStatus(QuotationId, {"status":"Request Rejected"});
    }
      
    var resdata = result?.message;
    notifySuccess(resdata);
    setIsConfirmModal(false); 
    setDataUpdate(!dataUpdate);
  }  

  const downloadFile = async () => {
	try {
	  const response = await fetch('https://example.com/api/file', {
		method: 'GET',
		headers: {
		  'Content-Type': 'application/pdf',
		},
	  });

	  if (!response.ok) {
		throw new Error('Network response was not ok');
	  }

	  const blob = await response.blob();
	  const url = window.URL.createObjectURL(blob);

	  const link = document.createElement('a');
	  link.href = url;
	  link.setAttribute('download', 'filename.pdf'); // Replace with your desired file name
	  document.body.appendChild(link);
	  link.click();
	  link.parentNode.removeChild(link);
	  window.URL.revokeObjectURL(url);
	} catch (error) {
	  console.error('Download error:', error);
	} 
}

  useEffect(() => {
    // console.log(" id == ", id);
    if(!id) {
      setValue("employeeId", "");
      setValue("clientId", "");
      setValue("projectType", "");
      setValue("scheduleDate", "");   
      setValue("fromTime", "");
      setValue("toTime", "");
      setValue("status", ""); 
      setStatus("");
    }
  }, [id])
  
  return {
    register,
    handleSubmit,
    onSubmit, 
    errors,
    setviewData,
    viewData,
    isModal, setIsModal,  
    ShowEditValues,
    isViewModal, setIsViewModal,
    status, setStatus,
    changeStatusRequest, 
    isConfirmModal, setIsConfirmModal, handleConfirmQuotation, 
    imageUrl, setImageUrl, downloadFile
  };
};

export default useQuotationSubmit; 